import React from 'react';

interface IRectangle_15 {
    fill: string;
    id?: string;
}

const Rectangle_15: React.FC<IRectangle_15> = ({ fill, id }) => {
  return (
  <svg width="372" height="173" viewBox="0 0 372 173" fill="none" xmlns="http://www.w3.org/2000/svg">
  <mask id="mask0_1825_1667" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="372" height="173">
  <path d="M0 173H372V-4.52995e-06H0V173Z" fill={fill}/>
  </mask>
  <g mask="url(#mask0_1825_1667)">
  <rect y="-894" width="12" height="1961" fill={fill}/>
  <rect x="36" y="-894" width="12" height="1961" fill={fill}/>
  <rect x="72" y="-894" width="12" height="1961" fill={fill}/>
  <rect x="108" y="-894" width="12" height="1961" fill={fill}/>
  <rect x="144" y="-894" width="12" height="1961" fill={fill}/>
  <rect x="180" y="-894" width="12" height="1961" fill={fill}/>
  <rect x="216" y="-894" width="12" height="1961" fill={fill}/>
  <rect x="252" y="-894" width="12" height="1961" fill={fill}/>
  <rect x="288" y="-894" width="12" height="1961" fill={fill}/>
  <rect x="324" y="-894" width="12" height="1961" fill={fill}/>
  <rect x="360" y="-894" width="12" height="1961" fill={fill}/>
  </g>
  </svg>
  );
  };
  export default Rectangle_15;
